import { useTranslation, Trans } from 'react-i18next';
import styled from '@emotion/styled';
import { Button, Modal } from '@hotjar/hotsauce';

const Note = styled.div`
  font-weight: 600;
`;

interface ModalSearchResultInfoProps {
  isOpen: boolean;
  setOpen: (newValue: boolean) => void;
  onSubmit: () => void;
}

export const ModalSearchResultInfo = ({
  isOpen,
  setOpen,
  onSubmit,
}: ModalSearchResultInfoProps): JSX.Element => {
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      contentLabel={t('common:visitor-lookup.modals.search-result-title')}
      isOpen={isOpen}
      onClose={handleClose}
    >
      <Modal.Header title={t('common:visitor-lookup.modals.search-result-title')} />
      <Modal.Body>
        <div>
          {t('common:visitor-lookup.modals.once-complete')}
          <br />
          <br />
          <Note>
            <Trans i18nKey="common:visitor-lookup.modals.stop-tracking">
              If you’re tracking this user via API and wish to STOP collecting data about them
              completely, you need to either stop tracking them or let them know they can{' '}
              <a target="blank" href="https://www.hotjar.com/legal/compliance/opt-out">
                opt out of data collection
              </a>{' '}
              themselves.
            </Trans>
          </Note>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          id="modal-submit-button"
          onClick={() => {
            handleClose();
            onSubmit();
          }}
        >
          {t('common:visitor-lookup.modals.submit-button')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
